import React from "react";

const IconWarning = () => {
  // This svg is a copy from public/icons/collection/CloseLarge.svg
  // Without the fill values.
  // If you find out it no longer matches the original file, please update it
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="20" cy="19.9822" rx="20" ry="19.9822" fill="#D22D43" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0463 24.75C20.4263 24.75 20.7404 24.4678 20.7901 24.1018L20.7969 24V11C20.7969 10.5858 20.4608 10.25 20.0463 10.25C19.6662 10.25 19.3521 10.5322 19.3024 10.8982L19.2956 11V24C19.2956 24.4142 19.6317 24.75 20.0463 24.75ZM20.0463 29.75C20.8754 29.75 21.5476 29.0784 21.5476 28.25C21.5476 27.4216 20.8754 26.75 20.0463 26.75C19.2171 26.75 18.5449 27.4216 18.5449 28.25C18.5449 29.0784 19.2171 29.75 20.0463 29.75Z"
        fill="#F6F5F0"
      />
    </svg>
  );
};

export default IconWarning;
